module.exports = __webpack_public_path__ + "static/img/ai-loading.679a315.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai-loading.gif
// module id = EqZy
// module chunks = 1